'use strict';

angular.module('shiftTraderApp')
  .directive('positionCard', ['$q', '$timeout', 'UsersPositions', function ($q, $timeout, UsersPositions) {
    return {
      templateUrl: 'views/positionsAssignment/positionCard.html',
      restrict: 'A',
      scope: {
        position: '=positionCard',
        user: '=',
        restrict: '='
      },
      require: 'positionCard', // Require our own controller for use in `link`
      controllerAs: 'posCard',
      bindToController: true,
      controller: ['$scope', function ($scope) {
        var vm = this

        vm.state = {
          hasPosition: vm.user.$hasPosition(vm.position.id),
          usersPosition: lodash.find(vm.user.users_positions, { user_id: vm.user.id, position_id: vm.position.id }),
          ratingOpen: false
        }

        // If the UsersPosition is not defined for this position, create a template for it
        if (_.isUndefined(vm.state.usersPosition)) {
          vm.state.usersPosition = {
            id: null,
            user_id: vm.user.id,
            organization_id: vm.position.organization_id,
            position_id: vm.position.id,
            training: false,
            ranking: 0
          }
        }

        vm.toggleTraining = function(evt) {
          evt.preventDefault()
          evt.stopPropagation()

          if (!vm.restrict) {
            vm.state.usersPosition.training = !vm.state.usersPosition.training
            updateUsersPosition()
          }
        }

        vm.toggleRating = function(evt) {
          if (evt) {
            evt.preventDefault()
            evt.stopPropagation()
          }

          if (!vm.restrict) {
            vm.state.ratingOpen = !vm.state.ratingOpen
          }
        }

        vm.closeRating = function() {
          updateUsersPosition()
          vm.state.ratingOpen = false
        }

        function updateUsersPosition () {
          var promises = []
          var usersPositionIdx = lodash.findIndex(vm.user.users_positions, { user_id: vm.user.id, position_id: vm.position.id })
          promises.push(vm.user.users_positions[usersPositionIdx].$setInactive()
            .then(function (ups) {
              vm.user.users_positions.splice(usersPositionIdx, 1)
            }))

          promises.push(UsersPositions.create(vm.state.usersPosition)
            .then(function (newUp) {
              vm.user.users_positions.push(newUp)
            }))

          $q.all(promises)
            .then(function () {
              vm.state.hasPosition = vm.user.$hasPosition(vm.position.id)
              $scope.toggleCheckmark();
            })
        }

        vm.toggleSelection = function () {
          if (vm.restrict) { return }

          if (vm.state.hasPosition) {
            // Set the UsersPosition to inactive
            var usersPositionIdx = lodash.findIndex(vm.user.users_positions, { user_id: vm.user.id, position_id: vm.position.id })
            vm.user.users_positions[usersPositionIdx].$setInactive()
              .then(function (ups) {
                vm.user.users_positions.splice(usersPositionIdx, 1)
                vm.state.hasPosition = vm.user.$hasPosition(vm.position.id)
                $scope.toggleCheckmark();
              })
          } else {
            // Create a new UsersPosition record for the user
            var payload = {
              position_id: vm.position.id,
              user_id: vm.user.id,
              organization_id: vm.position.organization_id,
              training: vm.state.usersPosition.training,
              ranking: vm.state.usersPosition.ranking,
              active: true
            }
            UsersPositions.create(payload)
              .then(function (newUp) {
                vm.user.users_positions.push(newUp)
                vm.state.hasPosition = vm.user.$hasPosition(vm.position.id)
                $scope.toggleCheckmark()
                vm.state.ratingOpen = false
              })
          }
        }
      }],
      link: function (scope, elem, attrs, vm) {
        /**
         * Sets the correct state of the checkmark in the corner of the card.
         * The check indicates whether the user works the position (ie. has a
         * corresponding UsersPosition record for it).
         *
         * NOTE: This couldn't be done easily in CSS because the entry animation
         * is different from the exit animation. They must be triggered separately.
         */
        scope.toggleCheckmark = function () {
          if (vm.state.hasPosition) {
            $timeout(function () {
              $(elem).find('.has-position > .checkmark').css('display', 'inline-block')
            })
          } else {
            $(elem).find('.has-position').css('opacity', 0)
            $timeout(function () {
              $(elem).find('.has-position > .checkmark').css('display', 'none')
              $(elem).find('.has-position').css('opacity', 1)
            }, 300)
          }
        }

        // Set the checkmark state of the card.
        scope.toggleCheckmark()
      }
    }
  }])
